<template>
  <div class="col responsive-width">
    <div class="content min-vh-100">
      <authorization-banner/>
      <div class="container-fluid">
        <div class="headers d-flex">
          <h1 class="mb-0">{{ $t("contracts") }}</h1>
          <router-link class="ms-auto" :to="{ name: 'createContract' }">
            <svg
                width="31"
                height="30"
                viewbox="0 0 31 30"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
              <path
                  d="M22.6541 0C27.7541 0 30.6641 2.88 30.6641 7.995V22.005C30.6641 27.09 27.7691 30 22.6691 30H8.65906C3.54406 30 0.664062 27.09 0.664062 22.005V7.995C0.664062 2.88 3.54406 0 8.65906 0H22.6541ZM15.6491 8.265C14.9591 8.265 14.4041 8.82 14.4041 9.51V13.74H10.1591C9.82906 13.74 9.51406 13.875 9.27406 14.1C9.04906 14.34 8.91406 14.6535 8.91406 14.985C8.91406 15.675 9.46906 16.23 10.1591 16.245H14.4041V20.49C14.4041 21.18 14.9591 21.735 15.6491 21.735C16.3391 21.735 16.8941 21.18 16.8941 20.49V16.245H21.1541C21.8441 16.23 22.3991 15.675 22.3991 14.985C22.3991 14.295 21.8441 13.74 21.1541 13.74H16.8941V9.51C16.8941 8.82 16.3391 8.265 15.6491 8.265Z"
                  fill="#7754FB"
              ></path>
            </svg>
          </router-link>
          <button
              v-if="canUseDeviceDiscrepancyReport"
              class="btn btn-outline-primary ms-2"
              @click="showDeviceDiscrepancyModal"
          >
            {{ $t("device_discrepancy_report") }}
          </button>
          <button
              class="btn btn-outline-primary sync-btn"
              v-on:click="syncContract"
          >
            <i
                class="bx bx-refresh bx-xs"
                :class="{ 'bx-spin': syncing === true }"
            ></i>
          </button>
        </div>
        <nav>
          <div class="row g-0">
            <div class="col">
              <ul class="list-unstyled d-flex">
                <li
                    @click="getContractFilter('All')"
                    :class="selectedFilter === 'All' ? 'active-filter' : ''"
                    class="all"
                >
                  {{ $t("all") }}
                </li>
                <li
                    @click="getContractFilter('Inactive')"
                    :class="selectedFilter === 'Inactive' ? 'active-filter' : ''"
                    class="inactive"
                >
                  {{ $t("inactivated_contracts") }}
                </li>
                <li
                    @click="getContractFilter('Finished')"
                    :class="selectedFilter === 'Finished' ? 'active-filter' : ''"
                    class="terminated"
                >
                  {{ $t("terminated_contracts") }}
                </li>
                <li
                    @click="getContractFilter('Active')"
                    :class="selectedFilter === 'Active' ? 'active-filter' : ''"
                    class="active"
                >
                  {{ $t("active_contracts") }}
                </li>
                <li
                    @click="getContractFilter(true)"
                    :class="selectedFilter === 'Upcoming' ? 'active-filter' : ''"
                    class="upcoming"
                >
                  {{ $t("upcoming") }}
                </li>
              </ul>
            </div>
            <div class="col">
              <div class="right-parent">
                <div class="filter d-flex">
                  <label>Filter</label>

                  <custom-select-drop-down :width="`175px`" :options="optionsList" @onPicked="onPicked"
                                           :default-value="defaultValue" :key="defaultValue"/>
                  <button @click="clearFilter()" style="height: 25px">{{ $t("clearFilter") }}</button>
                </div>
                <div class="d-flex flex-wrap align-items-center">
                  <div class="search">
                    <label for="search">
                      <svg
                          width="15"
                          height="15"
                          viewbox="0 0 15 15"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                            d="M14.6219 13.5596L10.0568 8.99453C10.7652 8.07871 11.1484 6.95898 11.1484 5.78125C11.1484 4.37148 10.5982 3.04961 9.60332 2.05293C8.6084 1.05625 7.28301 0.507812 5.875 0.507812C4.46699 0.507812 3.1416 1.05801 2.14668 2.05293C1.15 3.04785 0.601562 4.37148 0.601562 5.78125C0.601562 7.18926 1.15176 8.51465 2.14668 9.50957C3.1416 10.5063 4.46523 11.0547 5.875 11.0547C7.05273 11.0547 8.1707 10.6715 9.08652 9.96484L13.6516 14.5281C13.6649 14.5415 13.6808 14.5521 13.6983 14.5594C13.7158 14.5666 13.7346 14.5704 13.7535 14.5704C13.7725 14.5704 13.7912 14.5666 13.8087 14.5594C13.8262 14.5521 13.8421 14.5415 13.8555 14.5281L14.6219 13.7635C14.6353 13.7501 14.6459 13.7342 14.6531 13.7167C14.6604 13.6992 14.6641 13.6805 14.6641 13.6615C14.6641 13.6426 14.6604 13.6238 14.6531 13.6063C14.6459 13.5889 14.6353 13.573 14.6219 13.5596ZM8.65938 8.56563C7.91406 9.30918 6.92617 9.71875 5.875 9.71875C4.82383 9.71875 3.83594 9.30918 3.09063 8.56563C2.34707 7.82031 1.9375 6.83242 1.9375 5.78125C1.9375 4.73008 2.34707 3.74043 3.09063 2.99688C3.83594 2.25332 4.82383 1.84375 5.875 1.84375C6.92617 1.84375 7.91582 2.25156 8.65938 2.99688C9.40293 3.74219 9.8125 4.73008 9.8125 5.78125C9.8125 6.83242 9.40293 7.82207 8.65938 8.56563Z"
                            fill="#8F8E94"
                        ></path>
                      </svg>
                    </label>
                    <input
                        @input="searchField"
                        id="search"
                        v-model="searchValue"
                        type="text"
                        :placeholder="$t('search')"
                    />
                  </div>
                  <div class="customize">
                    <a
                        class="d-flex"
                        href="javascript:void(0);"
                        @click="openContractCustomizationModal = true"
                    >
                      <svg
                          width="14"
                          height="13"
                          viewbox="0 0 14 13"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                            d="M5.83724 7.2474H1.58724C1.39938 7.2474 1.21921 7.32202 1.08637 7.45486C0.953534 7.5877 0.878906 7.76787 0.878906 7.95573V12.2057C0.878906 12.3936 0.953534 12.5738 1.08637 12.7066C1.21921 12.8394 1.39938 12.9141 1.58724 12.9141H5.83724C6.0251 12.9141 6.20527 12.8394 6.33811 12.7066C6.47094 12.5738 6.54557 12.3936 6.54557 12.2057V7.95573C6.54557 7.76787 6.47094 7.5877 6.33811 7.45486C6.20527 7.32202 6.0251 7.2474 5.83724 7.2474ZM5.12891 11.4974H2.29557V8.66406H5.12891V11.4974ZM12.9206 0.164062H8.67057C8.48271 0.164063 8.30254 0.23869 8.16971 0.371528C8.03687 0.504367 7.96224 0.684534 7.96224 0.872396V5.1224C7.96224 5.31026 8.03687 5.49042 8.16971 5.62326C8.30254 5.7561 8.48271 5.83073 8.67057 5.83073H12.9206C13.1084 5.83073 13.2886 5.7561 13.4214 5.62326C13.5543 5.49042 13.6289 5.31026 13.6289 5.1224V0.872396C13.6289 0.684534 13.5543 0.504367 13.4214 0.371528C13.2886 0.23869 13.1084 0.164063 12.9206 0.164062ZM12.2122 4.41406H9.37891V1.58073H12.2122V4.41406ZM12.9206 9.3724H11.5039V7.95573C11.5039 7.76787 11.4293 7.5877 11.2964 7.45486C11.1636 7.32202 10.9834 7.2474 10.7956 7.2474C10.6077 7.2474 10.4275 7.32202 10.2947 7.45486C10.1619 7.5877 10.0872 7.76787 10.0872 7.95573V9.3724H8.67057C8.48271 9.3724 8.30254 9.44702 8.16971 9.57986C8.03687 9.7127 7.96224 9.89287 7.96224 10.0807C7.96224 10.2686 8.03687 10.4488 8.16971 10.5816C8.30254 10.7144 8.48271 10.7891 8.67057 10.7891H10.0872V12.2057C10.0872 12.3936 10.1619 12.5738 10.2947 12.7066C10.4275 12.8394 10.6077 12.9141 10.7956 12.9141C10.9834 12.9141 11.1636 12.8394 11.2964 12.7066C11.4293 12.5738 11.5039 12.3936 11.5039 12.2057V10.7891H12.9206C13.1084 10.7891 13.2886 10.7144 13.4214 10.5816C13.5543 10.4488 13.6289 10.2686 13.6289 10.0807C13.6289 9.89287 13.5543 9.7127 13.4214 9.57986C13.2886 9.44702 13.1084 9.3724 12.9206 9.3724ZM5.83724 0.164062H1.58724C1.39938 0.164063 1.21921 0.23869 1.08637 0.371528C0.953534 0.504367 0.878906 0.684534 0.878906 0.872396V5.1224C0.878906 5.31026 0.953534 5.49042 1.08637 5.62326C1.21921 5.7561 1.39938 5.83073 1.58724 5.83073H5.83724C6.0251 5.83073 6.20527 5.7561 6.33811 5.62326C6.47094 5.49042 6.54557 5.31026 6.54557 5.1224V0.872396C6.54557 0.684534 6.47094 0.504367 6.33811 0.371528C6.20527 0.23869 6.0251 0.164063 5.83724 0.164062ZM5.12891 4.41406H2.29557V1.58073H5.12891V4.41406Z"
                            fill="#5855D6"
                        ></path>
                      </svg>
                      {{ $t("customize") }}</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </nav>

        <div class="box">
          <div
              :class="[
              'box-responsive',
              `cols-count-${contractCustomizeItem.length + 2}`,
            ]"
          >
            <table>
              <thead>
              <tr>
                <th width="30" class="text-center">
                  <div class="checkbo">
                    <input
                        type="checkbox"
                        v-model="toggleChangeCheckbox"
                        class="form-check-input"
                        @change="toggleAllCheckbox"
                    />
                  </div>
                </th>
                <th v-for="(item, i) in tableHeader" :key="i">
                  <div style="display: flex">
                      <span>{{ $t(item) }}</span
                      ><span
                      class="th-soring"
                      v-if="!item_to_exclude.includes(item)"
                  >
                        <i
                            class="bx bx-chevron-up bx-xs el-clickable"
                            v-if="sortableColumns.includes(item)"
                            v-on:click="sortAscBy(i, item)"
                        ></i>
                        <i
                            class="bx bx-chevron-down bx-xs el-clickable"
                            v-if="sortableColumns.includes(item)"
                            v-on:click="sortDescBy(i, item)"
                        ></i>
                      </span>
                  </div>
                </th>
                <th width="90"><span>Actions</span></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(contract, i) in CONTRACTS.data" :key="i">
                <ContractTable
                    :data="contract"
                    :head="tableHeader"
                    @openTag="openTag"
                    @toggleAction="toggleAction"
                    @toggleActivity="toggleActivity"
                    @singleRowSchedule="singleRowSchedule"
                    @singleRowPrice="singleRowPrice"
                />
              </tr>
              </tbody>
            </table>
          </div>

          <div
              v-if="CONTRACTS.length < 1"
              class="d-flex justify-content-center"
          >
            <div class="loader">Loading...</div>
          </div>
        </div>
        <div class="actions d-flex align-items-center">
          <label>{{ $t("actions") }}</label>
          <select v-model="action">
            <option value="createinvoice">{{ $t("create_invoice") }}</option>
            <option value="finish">{{ $t("finished") }}</option>
            <option value="increaseinvoicecount">
              {{ $t("increase_invoice_count") }}
            </option>
            <option value="schedule">
              {{ $t("schedule_contract_cancelling") }}
            </option>
            <option value="update_contract_prices">
              {{ $t("update_contract_prices") }}
            </option>
          </select>
          <button :disabled="applying" @click="applyAction">
            <span v-if="applying">{{ $t("applying") }}</span>
            <span v-else>{{ $t("apply") }}</span>
          </button>
          <button class="ms-4" @click="openTagBottom">{{ $t("tags") }}</button>
          <div class="d-flex justify-content-end w-full">
            <div style="margin-right: 20px">
              <p class="list-summary">
                <select v-model="limit" v-on:change="onChange">
                  <option value="50">50</option>
                  <option value="100">100</option>
                  <option value="200">200</option>
                </select>
                {{ $t("of") }} {{ CONTRACTS.total_resources }}
              </p>
            </div>
            <v-pagination
                v-model="CONTRACTS.page"
                :pages="CONTRACTS.total_pages"
                :range-size="1"
                active-color="#DCEDFF"
                @update:modelValue="changePageNumber"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
  <ModalBoxVue
      v-show="openContractCustomizationModal"
      @handleClose="openContractCustomizationModal = false"
      :close="!true"
  >
    <h4>{{ $t("customization_contract") }}</h4>

    <div class="container p-3">
      <p>Uppdatera ordningen på kolumnerna <small> (drag &amp; drop)</small></p>
      <!-- list all visible columns -->
      <div class="row small">
        <div class="col-md-12">
          <!-- draggable list of visible columns -->

          <ul class="list-group" id="sortlist">
            <li
                v-for="item in contractCustomizeItem"
                :key="item"
                class="list-group-item list-group-item-action"
                style="cursor: grab"
            >
              <div class="d-flex justify-content-start">
                <img
                    style="width: 20px; height: 20px; margin-right: 10px"
                    src="../../assets/images/icon-utility/drag-and-drop.svg"
                    alt="d&amp;d-icon"
                />
                <div>
                  <span>{{ $t(item) }}</span>
                </div>
              </div>
            </li>
          </ul>
          <!-- <div class="list-group" v-for="(item, i) in tableHeader" :key="i">
            <p
              class="list-group-item list-group-item-action"
              :class="{
                active: item == activeColumn,
                disabled: item_to_exclude.includes(item),
              }"
              @click="setActiveColumn(item)"
            >
              {{ $t(item) }}
            </p>
          </div> -->
        </div>
      </div>
    </div>

    <div class="container p-3">
      <p>{{ $t("select_columns") }}</p>
      <form @submit.prevent="updateContractCustomization">
        <div class="customize-cols-scrollar">
          <div
              class="form-check"
              v-for="(item, i) in Object.keys(CONTRACT_CUSTOMIZATION)"
              :key="i"
          >
            <input
                class="form-check-input"
                v-model="contractCustomizeItem"
                type="checkbox"
                :value="item"
            />
            <label class="form-check-label" for="flexCheckDefault">
              {{ CONTRACT_CUSTOMIZATION[item] }}
            </label>
          </div>
        </div>
        <div class="col-md-12 mt-2">
          <button type="submit" :disabled="updating" class="btn btn-primary">
            <span v-if="updating">{{ $t("updating") }}...</span>
            <span v-else>{{ $t("update") }}</span>
          </button>
        </div>
      </form>
    </div>
  </ModalBoxVue>
  <ModalBoxVue
      v-if="openDeviceDiscrepancyModal"
      @handleClose="closeDeviceDiscrepancyModal"
      :close="!true"
  >
    <h4>{{ $t("device_discrepancy_report") }}</h4>
    <div class="container p-3">
      <div class="col-md-12">
        <label>{{ $t("upload_device_csv") }}</label>
        <input
            ref="deviceDiscrepancyFileInput"
            type="file"
            class="form-control"
            accept=".csv"
            @change="onDeviceDiscrepancyFileChange"
        />
      </div>
      <small class="text-muted">{{ $t("device_discrepancy_limit_note") }}</small>
      <div class="col-md-12 mt-3">
        <button
            class="btn btn-primary me-2"
            :disabled="deviceDiscrepancyLoading || !deviceDiscrepancyFile"
            @click="submitDeviceDiscrepancyReport"
        >
          <span v-if="deviceDiscrepancyLoading">{{ $t("generating") }}...</span>
          <span v-else>{{ $t("generate_report") }}</span>
        </button>
        <button
            class="btn btn-outline-secondary me-2"
            :disabled="deviceDiscrepancyDownloading || !deviceDiscrepancyDownloadReady"
            @click="downloadDeviceDiscrepancyReport"
        >
          <span v-if="deviceDiscrepancyDownloading">{{ $t("downloading") }}...</span>
          <span v-else>{{ $t("download_report") }}</span>
        </button>
        <button
            class="btn btn-danger"
            :disabled="deviceDiscrepancyLoading"
            @click="closeDeviceDiscrepancyModal"
        >
          {{ $t("cancel") }}
        </button>
      </div>
      <div class="col-md-12 mt-3" v-if="deviceDiscrepancyStatus">
        <small>{{ $t("report_status") }}: {{ deviceDiscrepancyStatus }}</small>
      </div>
      <div class="col-md-12 mt-2" v-if="deviceDiscrepancyError">
        <small class="text-danger">{{ deviceDiscrepancyError }}</small>
      </div>
    </div>
  </ModalBoxVue>
  <ModalBoxVue
      v-if="openTagAddition"
      @handleClose="openTagAddition = false"
      :close="!true"
  >
    <h4>Tags</h4>
    <div class="container p-3">
      <!-- <small>Select table heads (Multiple)</small> -->
      <div class="row">
        <div class="col-md-4 mb-4" v-for="(item, i) in GET_TAGS" :key="i">
          <span
              class="position-absolute tags-box cursor-pointer"
              @click="removeTag(item.id)"
          >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                style="color: red"
                class="h-5 w-5"
                viewBox="0 0 20 20"
                fill="currentColor"
            >
              <path
                  fill-rule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                  clip-rule="evenodd"
              />
            </svg>
          </span>
          <div class="border rounded p-2 bg-gray">
            <span class="d-flex align-items-center">
              <input
                  class="form-check-input"
                  :value="item.name"
                  type="checkbox"
                  v-model="tagSelection"
              />
              <small class="ml-2 tag-label">{{ item.name }}</small>
            </span>
          </div>
        </div>
      </div>
      <form class="row" @submit.prevent="addNewTags">
        <div class="col-md-8">
          <input
              class="form-control"
              v-model="tag"
              type="text"
              :placeholder="$t('add_tags')"
          />
        </div>
        <div class="col-md-4 d-flex justify-content-end">
          <button
              v-if="showAssignBtn"
              @click="assignTagContracts"
              :disabled="assigning"
              class="btn btn-success me-2 w-100"
          >
            <span v-if="assigning">{{ $t("assigning") }}...</span>
            <span v-else>{{ $t("assign") }}</span>
          </button>
          <button
              type="submit"
              :disabled="updating"
              class="btn btn-primary w-100"
          >
            <span v-if="updating">{{ $t("updating") }}...</span>
            <span v-else>{{ $t("save") }}</span>
          </button>
        </div>
      </form>
    </div>
  </ModalBoxVue>
  <ModalBoxVue
      v-if="openScheduleContractCancelationModal"
      @handleClose="openScheduleContractCancelationModal = false"
      :close="!true"
  >
    <h4>{{ $t("schedule_contract_cancelling") }}</h4>
    <div class="container p-3">
      <!-- <form @submit.prevent="updateContractCustomization"> -->
      <form @submit.prevent>
        <div class="customize-cols-scrollar">
          <div class="col-md-8">
            <small>{{ $t("date_to_cancel") }}</small>
            <Datepicker
                class="form-control"
                v-model="date_to_cancel"
                format="yyyy-MM-dd"
                :enableTimePicker="false"
                :minDate="today"
            />
          </div>
          <div class="col-md-8">
            <label>{{ $t("type_of_cancellation") }}</label>
            <select v-model="type_of_cancellation" class="form-control">
              <option value="" selected>{{ $t("choose_an_option") }}</option>
              <option value="inactivate">{{ $t("inactivate") }}</option>
              <option value="terminate">{{ $t("terminate") }}</option>
            </select>
          </div>
        </div>
        <div class="col-md-12 mt-2">
          <!-- if current row already has scheduled contract cancellation -->
          <span v-if="!isBulk && targetRow.scheduled_termination.length">
            <button
                :disabled="scheduling || !canSubmitScheduleContractCancellation"
                class="btn btn-primary"
                @click="updateScheduleContractCancelation()"
            >
              {{ $t("update") }}
            </button>
            <button
                :disabled="scheduling"
                class="btn btn-warning"
                @click="deleteScheduleContractCancelation"
            >
              {{ $t("delete") }}
            </button>
          </span>

          <!-- if current row does not have a scheduled contract cancellation -->
          <button
              v-else
              :disabled="scheduling || !canSubmitScheduleContractCancellation"
              class="btn btn-primary"
              @click="addScheduleContractCancelation()"
          >
            {{ $t("save") }}
          </button>

          <button
              :disabled="scheduling"
              class="btn btn-danger"
              @click="openScheduleContractCancelationModal = false"
          >
            {{ $t("cancel") }}
          </button>
        </div>
      </form>
    </div>
  </ModalBoxVue>
  <!-- Warning modal which shows info of those checked objects which already have scheduled cancellation -->
  <ModalBoxVue
      v-if="openAlreadyScheduledModal"
      @handleClose="openAlreadyScheduledModal = false"
      :close="!true"
  >
    <h4>{{ $t("already_scheduled_modal_title") }}</h4>
    <div class="container p-3">
      <div class="customize-cols-scrollar">
        <div class="col-md-8">
          <small>{{ $t("already_scheduled_modal_list_label") }}</small>
          <ul>
            <li v-for="item in alreadyScheduled" :key="item.id">
              <b
              >{{ $t("contract") }}
                {{ item.scheduled_termination[0].document_number }}</b
              >: {{ item.scheduled_termination[0].date_to_cancel }}
            </li>
          </ul>
        </div>
        <small>
          {{ $t("already_scheduled_modal_note1") }}
          <svg style="width: 20px; height: 19px" viewBox="0 0 24 24">
            <path
                fill="#5855d6"
                d="M9,10V12H7V10H9M13,10V12H11V10H13M17,10V12H15V10H17M19,3A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5C3.89,21 3,20.1 3,19V5A2,2 0 0,1 5,3H6V1H8V3H16V1H18V3H19M19,19V8H5V19H19M9,14V16H7V14H9M13,14V16H11V14H13M17,14V16H15V14H17Z"
            />
          </svg>
          {{ $t("already_scheduled_modal_note2") }}
        </small>
        <button
            class="btn btn-primary"
            v-if="bulkScheduled.length"
            @click="toggleScheduleContractCancelationModal()"
        >
          {{ $t("proceed") }}
        </button>
        <div v-else>
          <small>{{ $t("select_unscheduled_row") }}</small>
          <button
              class="btn btn-warning"
              @click="openAlreadyScheduledModal = false"
          >
            {{ $t("ok") }}
          </button>
        </div>
      </div>
    </div>
  </ModalBoxVue>
  <!-- Price change modal -->
  <ModalBoxVue
      v-if="openPriceChangeModal"
      @handleClose="openPriceChangeModal = false"
      :close="!true"
  >
    <contract-price-update-component :help-text="helpText" :is-bulk="isBulk" :target-row="targetRow"
                                     :exclude-row="excludeRow"
                                     :contract-row-list="contractRowList" :bulk-scheduled="bulkScheduled"
                                     :has-many-contract="hasManyContract"/>
    <h4 style="display: none">{{ $t("update_contract_price") }}</h4>
    <div class="container p-3" style="display: none">
      <!-- <form @submit.prevent="updateContractCustomization"> -->
      <form @submit.prevent>
        <div class="customize-cols-scrollar form">

          <div class="col-md-12">
            <div class="mb-3">
              <small class="mb-1">{{ $t("date_to_change_price") }}</small>
              <Datepicker
                  class="form-control"
                  v-model="contractPriceUpdateDate"
                  format="yyyy-MM-dd"
                  :enableTimePicker="false"
                  :minDate="today"
              />
            </div>
          </div>
          <div class="col-md-12">
            <div class="mb-3">
              <label class="mb-1">{{ $t("type_of_price_change") }}</label>
              <select v-model="contractPriceChangeType" class="form-control w-100">
                <option value="" selected>{{ $t("choose_an_option") }}</option>
                <option :value="item" v-for="(item,i) in actionList" :key="i">{{ $t(`${item}`) }}</option>
                <!--                <option value="decrease">{{ $t("decrease") }}</option>-->
              </select>
            </div>
          </div>

          <div class="col-md-12">
            <div class="mb-3">
              <label class="mb-1">
                <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                      d="M7.5 13.75C4.04813 13.75 1.25 10.9519 1.25 7.5C1.25 4.04813 4.04813 1.25 7.5 1.25C10.9519 1.25 13.75 4.04813 13.75 7.5C13.75 10.9519 10.9519 13.75 7.5 13.75ZM7.5 12.5C8.82608 12.5 10.0979 11.9732 11.0355 11.0355C11.9732 10.0979 12.5 8.82608 12.5 7.5C12.5 6.17392 11.9732 4.90215 11.0355 3.96447C10.0979 3.02678 8.82608 2.5 7.5 2.5C6.17392 2.5 4.90215 3.02678 3.96447 3.96447C3.02678 4.90215 2.5 6.17392 2.5 7.5C2.5 8.82608 3.02678 10.0979 3.96447 11.0355C4.90215 11.9732 6.17392 12.5 7.5 12.5ZM6.875 9.375H8.125V10.625H6.875V9.375ZM8.125 8.34687V8.75H6.875V7.8125C6.875 7.64674 6.94085 7.48777 7.05806 7.37056C7.17527 7.25335 7.33424 7.1875 7.5 7.1875C7.67755 7.18749 7.85144 7.13706 8.00145 7.04208C8.15146 6.9471 8.27142 6.81148 8.34736 6.65099C8.4233 6.4905 8.45211 6.31175 8.43043 6.13553C8.40875 5.95931 8.33747 5.79287 8.2249 5.65557C8.11232 5.51827 7.96307 5.41577 7.79451 5.35998C7.62596 5.30419 7.44502 5.29742 7.27277 5.34044C7.10051 5.38346 6.94401 5.47452 6.82148 5.60301C6.69895 5.7315 6.61542 5.89215 6.58063 6.06625L5.35438 5.82062C5.4304 5.44068 5.60594 5.08773 5.86308 4.79787C6.12021 4.508 6.4497 4.29161 6.81787 4.17083C7.18604 4.05004 7.57968 4.02918 7.95855 4.11038C8.33742 4.19159 8.68794 4.37195 8.97426 4.63302C9.26059 4.89408 9.47245 5.2265 9.58819 5.59629C9.70394 5.96608 9.71942 6.35997 9.63304 6.73769C9.54666 7.11542 9.36153 7.46344 9.09658 7.74616C8.83162 8.02889 8.49633 8.23619 8.125 8.34687Z"
                      fill="#5A58BA"/>
                </svg>
                <span v-if="['increase_percentage', 'decrease_percentage',].includes(contractPriceChangeType) === true">{{
                    $t("percentage_to_change_price")
                  }}</span>
                <span v-else> {{ $t("amount_to_change_price") }}</span>
              </label>
              <input
                  v-model="contractPriceChangePercentage"
                  class="form-control"
              />
            </div>
          </div>
          <div class="col-md-12" v-if="hasManyContract === false">
            <div class="mb-3">
              <label class="mb-1">
                <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                      d="M7.5 13.75C4.04813 13.75 1.25 10.9519 1.25 7.5C1.25 4.04813 4.04813 1.25 7.5 1.25C10.9519 1.25 13.75 4.04813 13.75 7.5C13.75 10.9519 10.9519 13.75 7.5 13.75ZM7.5 12.5C8.82608 12.5 10.0979 11.9732 11.0355 11.0355C11.9732 10.0979 12.5 8.82608 12.5 7.5C12.5 6.17392 11.9732 4.90215 11.0355 3.96447C10.0979 3.02678 8.82608 2.5 7.5 2.5C6.17392 2.5 4.90215 3.02678 3.96447 3.96447C3.02678 4.90215 2.5 6.17392 2.5 7.5C2.5 8.82608 3.02678 10.0979 3.96447 11.0355C4.90215 11.9732 6.17392 12.5 7.5 12.5ZM6.875 9.375H8.125V10.625H6.875V9.375ZM8.125 8.34687V8.75H6.875V7.8125C6.875 7.64674 6.94085 7.48777 7.05806 7.37056C7.17527 7.25335 7.33424 7.1875 7.5 7.1875C7.67755 7.18749 7.85144 7.13706 8.00145 7.04208C8.15146 6.9471 8.27142 6.81148 8.34736 6.65099C8.4233 6.4905 8.45211 6.31175 8.43043 6.13553C8.40875 5.95931 8.33747 5.79287 8.2249 5.65557C8.11232 5.51827 7.96307 5.41577 7.79451 5.35998C7.62596 5.30419 7.44502 5.29742 7.27277 5.34044C7.10051 5.38346 6.94401 5.47452 6.82148 5.60301C6.69895 5.7315 6.61542 5.89215 6.58063 6.06625L5.35438 5.82062C5.4304 5.44068 5.60594 5.08773 5.86308 4.79787C6.12021 4.508 6.4497 4.29161 6.81787 4.17083C7.18604 4.05004 7.57968 4.02918 7.95855 4.11038C8.33742 4.19159 8.68794 4.37195 8.97426 4.63302C9.26059 4.89408 9.47245 5.2265 9.58819 5.59629C9.70394 5.96608 9.71942 6.35997 9.63304 6.73769C9.54666 7.11542 9.36153 7.46344 9.09658 7.74616C8.83162 8.02889 8.49633 8.23619 8.125 8.34687Z"
                      fill="#5A58BA"/>
                </svg>
                {{ $t("rowToExclude") }}</label>
              <el-select class="w-100" v-model="excludeRow" :placeholder="$t('select')" size="large" multiple>
                <el-option
                    v-for="(item,key) in contractRowList"
                    :key="`_list_${key}`"
                    :label="`Article number : ${item.article_number}, Description:  ${item.description}, Price : ${item.price} Quantity : ${item.delivered_quantity}`"
                    :value="item.row_id"
                />
              </el-select>
            </div>
          </div>
          <div class="col-md-12">
            <div class="mb-3">
              <label class="mb-1">
                <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                      d="M7.5 13.75C4.04813 13.75 1.25 10.9519 1.25 7.5C1.25 4.04813 4.04813 1.25 7.5 1.25C10.9519 1.25 13.75 4.04813 13.75 7.5C13.75 10.9519 10.9519 13.75 7.5 13.75ZM7.5 12.5C8.82608 12.5 10.0979 11.9732 11.0355 11.0355C11.9732 10.0979 12.5 8.82608 12.5 7.5C12.5 6.17392 11.9732 4.90215 11.0355 3.96447C10.0979 3.02678 8.82608 2.5 7.5 2.5C6.17392 2.5 4.90215 3.02678 3.96447 3.96447C3.02678 4.90215 2.5 6.17392 2.5 7.5C2.5 8.82608 3.02678 10.0979 3.96447 11.0355C4.90215 11.9732 6.17392 12.5 7.5 12.5ZM6.875 9.375H8.125V10.625H6.875V9.375ZM8.125 8.34687V8.75H6.875V7.8125C6.875 7.64674 6.94085 7.48777 7.05806 7.37056C7.17527 7.25335 7.33424 7.1875 7.5 7.1875C7.67755 7.18749 7.85144 7.13706 8.00145 7.04208C8.15146 6.9471 8.27142 6.81148 8.34736 6.65099C8.4233 6.4905 8.45211 6.31175 8.43043 6.13553C8.40875 5.95931 8.33747 5.79287 8.2249 5.65557C8.11232 5.51827 7.96307 5.41577 7.79451 5.35998C7.62596 5.30419 7.44502 5.29742 7.27277 5.34044C7.10051 5.38346 6.94401 5.47452 6.82148 5.60301C6.69895 5.7315 6.61542 5.89215 6.58063 6.06625L5.35438 5.82062C5.4304 5.44068 5.60594 5.08773 5.86308 4.79787C6.12021 4.508 6.4497 4.29161 6.81787 4.17083C7.18604 4.05004 7.57968 4.02918 7.95855 4.11038C8.33742 4.19159 8.68794 4.37195 8.97426 4.63302C9.26059 4.89408 9.47245 5.2265 9.58819 5.59629C9.70394 5.96608 9.71942 6.35997 9.63304 6.73769C9.54666 7.11542 9.36153 7.46344 9.09658 7.74616C8.83162 8.02889 8.49633 8.23619 8.125 8.34687Z"
                      fill="#5A58BA"/>
                </svg>
                {{ $t("invoiceTextOnPriceChange") }}</label>
              <textarea class="form-control " cols="5" row="5" maxlength="1000"
                        v-model="invoiceTextAfterPriceChange"></textarea>
            </div>
          </div>


        </div>
        <div class="col-md-12 mt-2">
          <span v-if="!isBulk && targetRow.scheduled_price_change.length">
            <button
                :disabled="!canUpdateContractPrice"
                class="btn btn-primary"
                @click="updateContractPriceUpdate()"
            >
              {{ $t("update") }}
            </button>
            <button class="btn btn-warning" @click="deleteContractPriceUpdate">
              {{ $t("delete") }}
            </button>
          </span>

          <button
              v-else
              :disabled="!canUpdateContractPrice || scheduling"
              class="btn btn-primary"
              @click="addContractPriceUpdate"
          >
            {{ $t("save") }}
          </button>

          <button
              :disabled="scheduling"
              class="btn btn-danger"
              @click="openPriceChangeModal = false"
          >
            {{ $t("cancel") }}
          </button>
        </div>
      </form>
    </div>
  </ModalBoxVue>
  <!-- Warning modal which shows info of those checked objects which already have price change -->
  <ModalBoxVue
      v-if="openAlreadyPriceChangeModal"
      @handleClose="openAlreadyPriceChangeModal = false"
      :close="!true"
  >
    <h4>{{ $t("already_price_change_modal_title") }}</h4>
    <div class="container p-3">
      <div class="customize-cols-scrollar">
        <div class="col-md-8">
          <small>{{ $t("already_price_change_modal_list_label") }}</small>
          <ul>
            <li v-for="item in alreadyScheduled" :key="item.id">
              <b
              >{{ $t("contract") }}
                {{ item.scheduled_price_change[0].document_number }}</b
              >: {{ item.scheduled_price_change[0].date_to_update }}
            </li>
          </ul>
        </div>
        <small>
          {{ $t("already_price_change_modal_note1") }}
          <svg style="width: 24px; height: 24px" viewBox="0 0 24 24">
            <path
                fill="#5855d6"
                d="M21.41 11.58L12.41 2.58C12.04 2.21 11.53 2 11 2H4C2.9 2 2 2.9 2 4V11C2 11.53 2.21 12.04 2.59 12.41L3 12.81C3.9 12.27 4.94 12 6 12C9.31 12 12 14.69 12 18C12 19.06 11.72 20.09 11.18 21L11.58 21.4C11.95 21.78 12.47 22 13 22S14.04 21.79 14.41 21.41L21.41 14.41C21.79 14.04 22 13.53 22 13S21.79 11.96 21.41 11.58M5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7M5 17V21H7V17H9L6 14L3 17H5Z"
            />
          </svg>
          {{ $t("already_price_change_modal_note2") }}
        </small>
        <button
            class="btn btn-primary"
            v-if="bulkScheduled.length"
            @click="toggleContractPricesModal"
        >
          {{ $t("proceed") }}
        </button>
        <div v-else>
          <small>{{ $t("select_price_unchanged_row") }}</small>
          <button
              class="btn btn-warning"
              @click="openAlreadyPriceChangeModal = false"
          >
            {{ $t("ok") }}
          </button>
        </div>
      </div>
    </div>
  </ModalBoxVue>
  <ModalBoxVue
      v-if="openFilterValueModal && applyFilter != `All`"
      @handleClose="openFilterValueModal = false"
      :close="!true"
  >
    <h4>Filtrera</h4>
    <div class="container p-3">
      <!-- <form @submit.prevent="updateContractCustomization"> -->
      <form @submit.prevent>
        <div
            v-if="applyFilter === `period_start=` || applyFilter === `period_end=`"
        >
          <div class="customize-cols-scrollar">
            <div class="w-full pb-3">
              <label class="pb-1" v-if="applyFilter === 'period_start='">{{ $t('period_start_from') }}</label>
              <label class="pb-1" v-if="applyFilter === 'period_end='">{{ $t('period_end_from') }}</label>
              <Datepicker
                  class="form-control"
                  v-model="filterParams.period_start"
                  format="yyyy-MM-dd"
                  style="width: 100%"
                  :enableTimePicker="false"
              />
            </div>
            <div class="w-full">
              <label class="pb-1" v-if="applyFilter === 'period_start='">{{ $t('period_start_to') }}</label>
              <label class="pb-1" v-if="applyFilter === 'period_end='">{{ $t('period_end_to') }}</label>
              <Datepicker
                  class="form-control"
                  v-model="filterParams.period_end"
                  format="yyyy-MM-dd"
                  style="width: 100%"
                  :enableTimePicker="false"
              />
            </div>
            <!-- :minDate="today" -->
          </div>
        </div>
        <div v-else-if="applyFilter === 'article_number='">
          <label class="pb-2">{{ $t('search_for_an_article') }}</label>
          <el-select
              v-model="filterParams.article_number"
              filterable
              remote
              class="w-100"
              size="large"
              reserve-keyword
              :placeholder="$t('searchArticle')"
              :remote-method="remoteArticleSearch"
              :loading="loadingData"
          >
            <el-option
                v-for="(item,key) in articleList"
                :key="key"
                :label="`${item.article_number} - ${item.description}`"
                :value="item.article_number"
            />
          </el-select>
        </div>
        <div v-else>
          <input
              v-model="filterValue"
              style="width: 100%"
              class="form-control"
              type="number"
              min="1"
              :placeholder="$t('Ange värde')"
          />
        </div>
        <div class="col-md-12 mt-2">
          <button class="btn btn-primary" @click="applyFiltering()">
            Ok
          </button>
        </div>
      </form>
    </div>
  </ModalBoxVue>
  <ModalBoxVue
      v-if="confirmModal"
      @handleClose="confirmModal = false"
      :close="!true"
  >
    <div class="container p-3 confirmModal">
      <img src="@/assets/images/modal/notify-warning.png" width="25%"/>
      <p>{{ $t("finishContractsConfirmation") }}?</p>
      <div class="confirmModalButtons">
        <button class="btn btn-outline-dark" @click="confirmModal = false">
          {{ $t("cancel") }}
        </button>
        <button class="btn btn-info--confirm" @click="applyAction(false)">
          {{ $t("yes") }}
        </button>
      </div>
    </div>
  </ModalBoxVue>
</template>

<script>
import {mapGetters} from "vuex";
import debounce from "lodash.debounce";
import FileSaver from "file-saver";
import ModalBoxVue from "../../components/ModalBox.vue";
import ContractTable from "./reusableComponents/ContractTable.vue";
import {
  CONTRACT_CUSTOMIZATION,
  CONTRACT_DEFAULT,
} from "./composables/customization";
import VPagination from "@hennge/vue3-pagination";
import "@hennge/vue3-pagination/dist/vue3-pagination.css";
import AuthorizationBanner from "./reusableComponents/AuthorizationBanner";
import moment from "moment";
import Datepicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import contractPriceUpdateComponent from "./reusableComponents/contractPriceUpdateComponent";
import customSelectDropDown from "../../components/customSelectDropDown";

const TODAY = moment().format("YYYY-MM-DD");

export default {
  name: "Contracts",
  components: {
    ContractTable,
    ModalBoxVue,
    VPagination,
    customSelectDropDown,
    AuthorizationBanner,
    contractPriceUpdateComponent,
    Datepicker,
  },
  data() {
    return {
      tableHeader: [],
      contractCustomizeItem: [],
      openContractCustomizationModal: false,
      openScheduleContractCancelationModal: false,
      confirmModal: false,
      confirm: false,
      searchValue: '',
      defaultValue: '',
      openFilterValueModal: false,
      CONTRACT_CUSTOMIZATION: CONTRACT_CUSTOMIZATION,
      optionsList: [
        {label: 'all', value: 'All'},
        {label: 'article_number', value: 'article_number='},
        {label: 'invoiceInterval', value: 'invoice_interval='},
        {label: 'contractLength', value: 'contract_length='},
        {label: 'invoicesRemaining', value: 'invoices_reamining='},
        {label: 'periodStartUntil', value: 'period_start='},
        {label: 'periodEndUntil', value: 'period_end='},
      ],
      updating: false,
      openTagAddition: false,
      openDeviceDiscrepancyModal: false,
      deviceDiscrepancyFile: null,
      deviceDiscrepancyReportId: null,
      deviceDiscrepancyStatus: "",
      deviceDiscrepancyError: "",
      deviceDiscrepancyLoading: false,
      deviceDiscrepancyDownloading: false,
      deviceDiscrepancyDownloadReady: false,
      deviceDiscrepancyPollTimer: null,
      loadingData: false,
      contractTags: [],
      articleList: [],
      tagSelection: [],
      tag: "",
      page: 1,
      limit: 50,
      applyFilter: "All",
      filterValue: "",
      filterParams: {
        period_start: "",
        period_end: "",
        article_number: ''
      },
      filter: null,
      assigning: false,
      applying: false,
      syncing: false,
      action: "",
      toggleChangeCheckbox: false,
      showAssignBtn: false,
      selectedData: {},
      item_to_exclude: ["tags"],
      date_to_cancel: TODAY,
      type_of_cancellation: "", //terminate or inactivate
      scheduling: false, //this is a flag which can be used to show loading spinner etc. Mainly used for disabling buttons when requests are being processed
      targetRow: {}, //object having all the data of a single row which caused the modal popup
      alreadyScheduled: [], //array of all the objects which are already scheduled, these objects will be displayed in the warning modal
      bulkScheduled: [], //array of all objects checked by the user which do not have any scheduled action
      isBulk: false, //flag to determine whether the action is called by a single row or bulk action
      hasManyContract: false, //flag to determine whether the action is called by a single row or bulk action
      contractRowList: [], //flag to determine whether the action is called by a single row or bulk action
      excludeRow: [], // Rows to exclude
      invoiceTextAfterPriceChange: '',
      openAlreadyScheduledModal: false, //flag to show warning modal. It is displayed if user selects those rows which already have scheduled cancellation
      contractPriceChangePercentage: 0, //percentage by which contract price will change
      contractPriceChangeType: "", // increace/decrease
      contractPriceUpdateDate: TODAY,
      openPriceChangeModal: false,
      openAlreadyPriceChangeModal: false,
      selectedFilter: "All",
      orderByColumn: null, // which column to order
      orderByQuery: "",
      helpText: [],
      actionList: ['increase_percentage', 'decrease_percentage', 'increase_amount', 'decrease_amount'],
      sortableColumns: [
        "category",
        "customer_name",
        "contract_date",
        "period_start",
        "period_end",
        "invoices_remaining",
        "contract_length",
        "invoice_interval",
        "currency",
        "total",
      ],
    };
  },
  watch: {
    tagSelection: function (newVal, oldVal) {
      if (
          (this.selectedData && this.selectedData.document_number) ||
          (newVal.length > 0 && this.GET_CONTRACT_CHECKED.data.length > 0)
      ) {
        this.showAssignBtn = true;
      } else {
        this.showAssignBtn = false;
      }
    },

    openContractCustomizationModal: function (newVal, oldVal) {
      if (newVal === true) {
        setTimeout(() => {
          this.slist(document.getElementById("sortlist"));
        }, 200);
      }
    },

    contractCustomizeItem: function (newVal, oldVal) {
      const list = document.getElementById("sortlist");
      if (list) {
        this.slist(list);
      }
    },
    action() {
      if (this.action === `finish`) {
        this.confirm = true;
      }
    },
  },
  computed: {
    ...mapGetters({
      CONTRACTS: "clients/GET_CONTRACTS",
      GET_CONTRACT_CHECKED: "clients/GET_CONTRACT_CHECKED",
      GET_TAGS: "clients/GET_TAGS",
      GET_USER_SUBSCRIPTION: "clients/GET_USER_SUBSCRIPTION",
      CURRENT_USER: "clients/GET_CURRENT_USER",
      GET_LOCALE: 'locale/GET_LOCALE',
      CONTRACT_FILTER: 'clients/GET_CONTRACT_FILTER'
    }),
    today() {
      return moment().format("YYYY-MM-DD");
    },
    canSubmitScheduleContractCancellation() {
      return this.date_to_cancel && this.type_of_cancellation;
    },
    canUpdateContractPrice() {
      return (
          this.contractPriceChangePercentage > 0 &&
          this.contractPriceChangeType &&
          this.contractPriceUpdateDate
      );
    },
    canUseDeviceDiscrepancyReport() {
      if (this.CURRENT_USER.access !== "Full") {
        return false;
      }
      if (!this.GET_USER_SUBSCRIPTION || this.GET_USER_SUBSCRIPTION.length < 1) {
        return false;
      }
      return !!this.GET_USER_SUBSCRIPTION[0].device_discrepancy_report_enabled;
    },
    locale_message: function () {
      return this.GET_LOCALE === 'se' ? 'message' : 'eng_message'
    }
  },
  mounted() {
    this.getContracts();
    this.getContractTags();
    this.getContractCustomizeHeader();
    this.getHelptext();
    window.Bus.on('reload-contract', e => {
      this.openPriceChangeModal = false
      this.getContracts();
      this.getContractCustomizeHeader();
    })
    window.Bus.on('close-contract-modal', e => {
      this.openPriceChangeModal = false
    })
    if (CONTRACT_DEFAULT) {
      Object.keys(CONTRACT_DEFAULT).forEach((el) => {
        this.contractCustomizeItem.push(el);
      });
    }
    this.getUserSubscription();

  },
  beforeUnmount() {
    this.stopDeviceDiscrepancyPolling();
  },
  methods: {
    onPicked: function (option) {
      this.applyFilter = option.value
      this.$store.commit('clients/UPDATE_CONTRACT_FILTER', {filter: option.label})
      this.onOpenFilter()
    },
    clearFilter() {
      this.filterValue = ''
      Object.keys(this.filterParams).map(k => {
        this.filterParams[k] = ''
      })
      this.defaultValue = ''
      this.searchValue = ''
      document.getElementById('search').value = ''
      this.$store.commit('clients/CLEAR_FILTER', 'contract')
      this.getContracts()
    },
    onOpenFilter() {
      this.filterValue = ''
      Object.keys(this.filterParams).map(k => {
        this.filterParams[k] = ''
      })
      if (this.applyFilter === 'All') {
        this.getContractFilter('All')
        return true
      }
      this.openFilterValueModal = true

    },
    remoteArticleSearch: debounce(function (query) {
      if (query) {
        this.loadingData = true
        this.newInvoiceId = "";
        this.$store
            .dispatch("clients/getProduct", `search=${query}&limit=100`)
            .then((res) => {
              this.loadingData = false
              this.articleList = res.data.data
            })
            .catch((err) => {
              this.loadingData = false
            });
      }
    }, 500),
    applyFiltering() {
      let payload = "";
      let savePayload = {}
      if (
          this.applyFilter === `period_start=` ||
          this.applyFilter === `period_end=`
      ) {
        let period_start = ''
        let period_end = ''
        if (this.filterParams.period_start) {
          period_start = moment(this.filterParams.period_start).format('YYYY-MM-DD')
        }
        if (this.filterParams.period_end) {
          period_end = moment(this.filterParams.period_end).format('YYYY-MM-DD')
        }
        if (this.applyFilter === 'period_start=') {
          if (period_start) {
            payload += `period_start_start=${period_start}&`
            savePayload['period_start_start'] = period_start
          }
          if (period_end) {
            payload += `period_start=${period_end}&`
            savePayload['period_start'] = period_end
          }
        }
        if (this.applyFilter === 'period_end=') {
          if (period_start) {
            payload += `period_end_start=${period_start}&`
            savePayload['period_end_start'] = period_start

          }
          if (period_end) {
            payload += `period_end=${period_end}&`
            savePayload['period_end'] = period_end
          }
        }
      } else {
        if (this.applyFilter === "invoice_interval=") {
          payload = `invoice_interval=${this.filterValue}&`;
          savePayload['invoice_interval'] = this.filterValue
        } else if (this.applyFilter === "contract_length=") {
          payload = `contract_length=${this.filterValue}&`;
          savePayload['contract_length'] = this.filterValue
        } else if (this.applyFilter === "invoices_reamining=") {
          payload = `invoices_reamining=${this.filterValue}&`;
          savePayload['invoices_reamining'] = this.filterValue
        }
      }
      if (this.filterParams.article_number && this.applyFilter === 'article_number=') {
        payload = `article_number=${this.filterParams.article_number}&`;
        savePayload['article_number'] = this.filterParams.article_number
      }
      this.$store.commit('clients/UPDATE_CONTRACT_FILTER', {filterValue: savePayload})
      this.$store.commit("clients/UPDATE_CONTRACTS", []);
      this.onChange()
      this.openFilterValueModal = false
    },
    getUserSubscription() {
      this.$store
          .dispatch("clients/getUserSubscription")
          .then((res) => {
            this.getPackageInfo();
          })
          .catch((err) => {
          });
    },

    getPackageInfo() {
      if (this.GET_USER_SUBSCRIPTION.length > 0) {
        if (
            !["free", "Free", "FREE"].includes(
                this.GET_USER_SUBSCRIPTION[0].current_package
            )
        ) {
          const payload = {
            URL:
                this.$services.endpoints.PACKAGE_ENDPOINT +
                `?package=${this.GET_USER_SUBSCRIPTION[0].current_package.toLowerCase()}`,
          };
          this.$store
              .dispatch("clients/getPlanDetails", payload)
              .then((res) => {
                if (
                    !res.data.results[0].dashboard_page_access.includes(
                        this.$route.name
                    )
                ) {
                  window.Bus.emit("access-denied", "contracts");
                }
              });
        } else {
          window.Bus.emit("access-denied", "contracts");
        }
      } else {
        this.getUserSubscription();
      }
    },
    showDeviceDiscrepancyModal() {
      if (!this.canUseDeviceDiscrepancyReport) {
        return;
      }
      this.openDeviceDiscrepancyModal = true;
    },
    closeDeviceDiscrepancyModal() {
      this.openDeviceDiscrepancyModal = false;
      this.resetDeviceDiscrepancyState();
    },
    resetDeviceDiscrepancyState() {
      this.deviceDiscrepancyFile = null;
      this.deviceDiscrepancyReportId = null;
      this.deviceDiscrepancyStatus = "";
      this.deviceDiscrepancyError = "";
      this.deviceDiscrepancyDownloadReady = false;
      this.deviceDiscrepancyLoading = false;
      this.deviceDiscrepancyDownloading = false;
      this.stopDeviceDiscrepancyPolling();
      if (this.$refs.deviceDiscrepancyFileInput) {
        this.$refs.deviceDiscrepancyFileInput.value = "";
      }
    },
    onDeviceDiscrepancyFileChange(e) {
      const file = e.target.files && e.target.files[0];
      if (!file) {
        this.deviceDiscrepancyFile = null;
        return;
      }
      if (!file.name.toLowerCase().endsWith(".csv")) {
        e.target.value = "";
        this.deviceDiscrepancyFile = null;
        this.$toast.error(this.$t("invalid_file_type"));
        return;
      }
      this.deviceDiscrepancyFile = file;
      this.deviceDiscrepancyError = "";
    },
    getDeviceDiscrepancyErrorMessage(err) {
      if (err && err.response && err.response.data) {
        const data = err.response.data;
        return data[this.locale_message] || data.message || data.eng_message || "Something went wrong";
      }
      return "Something went wrong";
    },
    submitDeviceDiscrepancyReport() {
      if (this.CURRENT_USER.access === "Read") {
        return this.$toast.info(this.$t("limited_read_access"));
      }
      if (!this.deviceDiscrepancyFile) {
        return this.$toast.warning(this.$t("select_file"));
      }
      this.deviceDiscrepancyLoading = true;
      this.deviceDiscrepancyError = "";
      this.deviceDiscrepancyStatus = "";
      this.deviceDiscrepancyDownloadReady = false;
      const formData = new FormData();
      formData.append("input_file", this.deviceDiscrepancyFile);
      this.$store
          .dispatch("clients/createDeviceDiscrepancyReport", formData)
          .then((res) => {
            const report = res.data.data;
            this.deviceDiscrepancyReportId = report.id;
            this.deviceDiscrepancyStatus = report.status;
            this.deviceDiscrepancyDownloadReady = report.download_ready;
            this.startDeviceDiscrepancyPolling();
          })
          .catch((err) => {
            const message = this.getDeviceDiscrepancyErrorMessage(err);
            this.deviceDiscrepancyError = message;
            this.$toast.error(message);
          })
          .finally(() => {
            this.deviceDiscrepancyLoading = false;
          });
    },
    startDeviceDiscrepancyPolling() {
      if (!this.deviceDiscrepancyReportId) {
        return;
      }
      this.stopDeviceDiscrepancyPolling();
      this.fetchDeviceDiscrepancyReportStatus();
      this.deviceDiscrepancyPollTimer = setInterval(() => {
        this.fetchDeviceDiscrepancyReportStatus();
      }, 2500);
    },
    stopDeviceDiscrepancyPolling() {
      if (this.deviceDiscrepancyPollTimer) {
        clearInterval(this.deviceDiscrepancyPollTimer);
        this.deviceDiscrepancyPollTimer = null;
      }
    },
    fetchDeviceDiscrepancyReportStatus() {
      if (!this.deviceDiscrepancyReportId) {
        return;
      }
      this.$store
          .dispatch(
              "clients/getDeviceDiscrepancyReport",
              this.deviceDiscrepancyReportId
          )
          .then((res) => {
            const report = res.data.data;
            this.deviceDiscrepancyStatus = report.status;
            this.deviceDiscrepancyError = report.error_message || "";
            this.deviceDiscrepancyDownloadReady = report.download_ready;
            if (report.status === "DONE" || report.status === "FAILED") {
              this.stopDeviceDiscrepancyPolling();
            }
          })
          .catch((err) => {
            const message = this.getDeviceDiscrepancyErrorMessage(err);
            this.deviceDiscrepancyError = message;
            this.stopDeviceDiscrepancyPolling();
          });
    },
    downloadDeviceDiscrepancyReport() {
      if (!this.deviceDiscrepancyReportId) {
        return;
      }
      this.deviceDiscrepancyDownloading = true;
      this.$store
          .dispatch(
              "clients/downloadDeviceDiscrepancyReport",
              this.deviceDiscrepancyReportId
          )
          .then((res) => {
            const fileName = `device_discrepancy_report_${this.deviceDiscrepancyReportId}.csv`;
            FileSaver.saveAs(res.data, fileName);
          })
          .catch((err) => {
            const message = this.getDeviceDiscrepancyErrorMessage(err);
            this.$toast.error(message);
          })
          .finally(() => {
            this.deviceDiscrepancyDownloading = false;
          });
    },
    syncContract: function () {
      if (this.CURRENT_USER.access === "Read") {
        return this.$toast.info(this.$t("limited_read_access"));
      }
      this.syncing = true;
      this.$store
          .dispatch("clients/syncResource", "contracts")
          .then(() => {
            this.syncing = false;
            // this.$services.helpers.notification('Contract synchronization in progress', 'success', this)
            this.$toast.info(this.$t("sync_contracts"));
          })
          .catch((err) => {
            this.syncing = false;
            // this.$services.helpers.notification('Contract could not be synchronized', 'error', this)
            this.$toast.info(this.$t("fail_sync_contracts"));
          });
    },
    getHelptext() {
      const payload = {
        URL:
        this.$services.endpoints.HELPTEXT_ENDPOINT
      };
      this.$store
          .dispatch("clients/getCustomRequest", payload)
          .then((res) => {
            this.helpText = res.data.results.filter(item => ['contract_price_update_price_change', 'contract_price_update_rows_to_exclude',
              'contract_price_update_invoice_text'].includes(item.field) === true)

          })
          .catch((err) => {
          });
    },
    sortAscBy(index, item) {
      this.orderByColumn = item;
      this.orderByQuery = `&ordering=${this.orderByColumn}`;
      this.$store.commit('clients/UPDATE_CONTRACT_FILTER', {sort: `${item}`})
      this.onChange();
      // this.$store.commit('clients/SORT_ASC', {'item': item, 'state': 'contract', 'copy': 'contractCopy'})
    },
    sortDescBy(index, item) {
      this.orderByColumn = item;
      this.orderByQuery = `&ordering=-${this.orderByColumn}`;
      this.$store.commit('clients/UPDATE_CONTRACT_FILTER', {sort: `-${item}`})
      this.onChange();
      // this.$store.commit('clients/SORT_DESC', {'item': item, 'state': 'contract', 'copy': 'contractCopy'})
    },
    onChange() {
      let payload = `limit=${this.limit}`;
      let params = this.computeQueryParams()
      if (params) {
        payload += params;
      }
      this.$store.dispatch(
          "clients/getContracts", payload
      );
    },
    searchField: debounce(function (event) {
      this.$store.commit('clients/UPDATE_CONTRACT_FILTER', {search: event.target.value})
      this.onChange()
    }, 500),
    filterSearch(data) {
      let payload = `limit=${this.limit}${this.computeQueryParams()}`
      if (this.selectedFilter === "Upcoming") {
        payload += '&category=Active'
      }
      this.$store.dispatch("clients/getContracts", payload);
    },
    getContracts() {
      this.selectedFilter = "Active";
      this.filter = null;
      this.$store.commit("clients/UPDATE_CONTRACTS", []);
      let payload = `limit=${this.limit}&category=Active` + this.orderByQuery;
      if (Object.keys(this.CONTRACT_FILTER).length > 0) {
        payload = `limit=${this.limit}` + this.computeQueryParams()

      } else {
        this.$store.commit('clients/UPDATE_CONTRACT_FILTER', {category: 'Active'})
      }
      this.$store.dispatch("clients/getContracts", payload);
    },
    getContractTags() {
      this.$store
          .dispatch("clients/getTags", "CONTRACT")
          .then((res) => {
            this.contractTags = res.data.results;
          })
          .catch((err) => {
            if (err.response.status === 401) {
              this.$store.commit("auth/CLEAR_AUTH_USER", null);
              window.Bus.emit("logout");
            }
          });
    },
    toggleAllCheckbox(e) {
      this.$store.commit(
          "clients/TOGGLE_ALL_CONTRACT_CHECKBOX",
          this.toggleChangeCheckbox
      );
    },
    getContractFilter(data) {
      let payload = "";
      if (data === true) {
        payload = "upcoming=True";
        this.selectedFilter = "Upcoming";
      } else {
        if (data !== 'All') {
          payload = `category=${data}`;
        }

        this.selectedFilter = data;
      }
      this.$store.commit('clients/UPDATE_CONTRACT_FILTER', {category: this.selectedFilter})
      this.$store.commit("clients/UPDATE_CONTRACTS", []);
      this.filter = payload;
      this.applyFilter = "All";
      this.onChange()
    },
    changePageNumber(number) {
      let payload = `limit=${this.limit}&page=${number}`;
      let computeParma = this.computeQueryParams()
      if (computeParma) {
        payload += computeParma
      }
      this.$store.commit("clients/UPDATE_CONTRACTS", []);
      this.$store.dispatch("clients/getContracts", payload);
    },
    computeQueryParams() {
      if (Object.keys(this.CONTRACT_FILTER).length <= 0) {
        return null
      }
      let payload = ''
      Object.keys(this.CONTRACT_FILTER).map(item => {
        if (this.CONTRACT_FILTER[item] === 'All') {
          this.selectedFilter = 'All'
        }
        if (item === 'category' && this.CONTRACT_FILTER[item] !== 'All') {
          if (this.CONTRACT_FILTER[item] === 'Upcoming') {
            payload += `&upcoming=True&category=Active`
            this.selectedFilter = 'Upcoming'
          } else {
            payload += `&category=${this.CONTRACT_FILTER[item]}`
            this.selectedFilter = this.CONTRACT_FILTER[item]
          }
        } else if ('filterValue' === item) {
          this.defaultValue = this.CONTRACT_FILTER['filter']
          if (typeof this.CONTRACT_FILTER[item] === 'object') {
            Object.keys(this.CONTRACT_FILTER[item]).map(k => {
              payload += `&${k}=${this.CONTRACT_FILTER[item][k]}`
            })
          }
        } else if (item === 'sort') {
          payload += `&ordering=${this.CONTRACT_FILTER[item]}`
        } else if (item === 'search') {
          if (this.CONTRACT_FILTER[item]) {
            payload += `&search=${this.CONTRACT_FILTER[item]}`
          }

          this.searchValue = this.CONTRACT_FILTER[item]
        }
      })

      return payload

    },
    getContractCustomizeHeader() {
      this.$store
          .dispatch("clients/getContractCustomizeHeader")
          .then((res) => {
            this.tableHeader = res.data.data;
            if (this.tableHeader.length > 0) {
              this.contractCustomizeItem = this.tableHeader;
            } else {
              if (CONTRACT_DEFAULT) {
                Object.keys(CONTRACT_DEFAULT).forEach((el) => {
                  this.contractCustomizeItem.push(el);
                });
              }
            }
          })
          .catch((err) => {
            if (err.response.status === 401) {
              this.$store.commit("auth/CLEAR_AUTH_USER", null);
              window.Bus.emit("logout");
            }
          });
    },
    updateContractCustomization() {
      if (this.contractCustomizeItem.length < 1) {
        // this.$services.helpers.notification('Please select columns', 'error', this)
        this.$toast.warning(this.$t("choose_columns"));
      } else {
        this.updating = true;
        this.$store
            .dispatch("clients/updateContractCustomization", {
              columns: this.contractCustomizeItem,
            })
            .then((res) => {
              this.updating = false;
              this.openContractCustomizationModal = false;
              this.getContracts();
              this.getContractCustomizeHeader();
              this.$services.helpers.notification(
                  res.data[this.locale_message],
                  "success",
                  this
              );
            })
            .catch((err) => {
              this.updating = false;
              this.$services.helpers.notification(
                  err.response.data[this.locale_message],
                  "error",
                  this
              );
            });
      }
    },
    applyAction() {
      if (
          this.action === "finish" &&
          this.confirm &&
          this.action != "" &&
          this.GET_CONTRACT_CHECKED.data.length >= 1
      ) {
        this.confirmModal = true;
        this.confirm = false;
      } else {
        if (this.action === "") {
          // this.$services.helpers.notification('Please select an action', 'error', this)
          this.$toast.warning(this.$t("choose_action"));
        } else if (this.GET_CONTRACT_CHECKED.data.length < 1) {
          // this.$services.helpers.notification('Please select a contract(s)', 'error', this)
          this.$toast.warning(this.$t("choose_contract"));
        } else if (this.action === "schedule") {
          // this.applying = true
          this.isBulk = true;
          this.targetRow = {}; //empty the targetRow
          this.alreadyScheduled = [];
          this.bulkScheduled = [];
          this.GET_CONTRACT_CHECKED.data.forEach((element) => {
            if (element.category !== "Finished") {
              if (!element.scheduled_termination.length) {
                this.bulkScheduled.push(parseInt(element.document_number));
              } else {
                this.alreadyScheduled.push(element);
              }
            }
          });

          if (!this.bulkScheduled.length) {
            this.$toast.warning(this.$t("invalid_row_selection_schedule"));
            return;
          }
          // check if the selection contains any alreadyScheduled rows
          if (this.alreadyScheduled.length) {
            this.openAlreadyScheduledModal = true;
          } else {
            this.toggleScheduleContractCancelationModal();
          }

          // this.openScheduleContractCancelationModal = true
        } else if (this.action === "update_contract_prices") {
          this.isBulk = true;
          this.targetRow = {}; // empty the targetRow
          this.alreadyScheduled = [];
          this.bulkScheduled = [];
          this.GET_CONTRACT_CHECKED.data.forEach((element) => {
            if (element.category !== "Finished") {
              // element.scheduled_price_change will be a list of all scheduled price changes on this contract, it comes from BE
              if (!element.scheduled_price_change.length) {
                this.bulkScheduled.push(parseInt(element.document_number));
              } else {
                this.alreadyScheduled.push(element);
              }
            }
          });
          this.contractRowList = []
          this.excludeRow = []
          this.invoiceTextAfterPriceChange = ''
          if (this.GET_CONTRACT_CHECKED.data.length > 1) {
            this.hasManyContract = true
          } else {
            this.hasManyContract = false
            this.contractRowList = this.GET_CONTRACT_CHECKED.data[0]['invoice_rows']
          }

          // check if the selection contains any alreadyScheduled rows
          if (!this.bulkScheduled.length) {
            this.$toast.warning(this.$t("invalid_row_selection_price_change"));
            return;
          }

          if (this.alreadyScheduled.length) {
            this.openAlreadyPriceChangeModal = true;
          } else {
            this.toggleContractPricesModal();
          }
        } else {
          this.confirm = true;
          this.applying = true;
          const array = [];
          this.GET_CONTRACT_CHECKED.data.forEach((element) => {
            array.push(parseInt(element.document_number));
          });

          const payload = {
            action: this.action,
            contracts: array,
          };
          this.$store
              .dispatch("clients/updateContractAction", payload)
              .then((res) => {
                // this.getContracts()
                this.applying = false;
                this.confirmModal = false;
                this.action = "";
                this.$store.commit("clients/TOGGLE_ALL_CONTRACT_CHECKBOX", false);
                this.$services.helpers.notification(
                    res.data.message,
                    "success",
                    this
                );
              })
              .catch((err) => {
                this.applying = false;
                this.confirmModal = false;
                this.$services.helpers.notification(
                    err.response.data.message,
                    "error",
                    this
                );
              });
        }
      }
    },
    toggleAction(data) {
      const array = [];
      this.GET_CONTRACT_CHECKED.data.forEach((element) => {
        array.push(parseInt(element.id));
      });

      const payload = {
        action: "finish",
        contracts: [data.id],
      };
      this.$store
          .dispatch("clients/updateContractAction", payload)
          .then((res) => {
            this.applying = false;
            this.action = "";
            this.$store.commit("clients/TOGGLE_ALL_CONTRACT_CHECKBOX", false);
            this.$services.helpers.notification(
                res.data.message,
                "success",
                this
            );
          })
          .catch((err) => {
            this.applying = false;
            this.$services.helpers.notification(
                err.response.data.message,
                "error",
                this
            );
          });
    },
    toggleActivity(data) {
      data.active = !data.active;
      this.$store
          .dispatch("clients/updateContract", data)
          .then((_) => {
            // this.getContracts()
            this.$store.commit("clients/TOGGLE_ALL_CUSTOMER_CHECKBOX", false);
            this.$services.helpers.notification(
                "Successfully toggle contract activity",
                "success",
                this
            );
          })
          .catch((err) => {
            this.$services.helpers.notification(
                err.response.data.message.data,
                "error",
                this
            );
          });
    },
    addNewTags() {
      if (this.tag === "") {
        return;
      } else {
        this.updating = true;
        const payload = {
          type: "CONTRACT",
          name: this.tag,
        };
        this.$store
            .dispatch("clients/addTags", payload)
            .then((res) => {
              this.updating = false;
              this.getContractTags();
            })
            .catch((err) => {
              this.updating = false;
              this.$services.helpers.notification(
                  err.response.data.message,
                  "error",
                  this
              );
            });
      }
    },
    assignTagContracts() {
      if (this.GET_CONTRACT_CHECKED.data.length > 0) {
        this.assigning = true;
        const array = [];
        const payload = {};
        payload.URL = this.$services.endpoints.CONTRACTS_ENDPOINT + "/bulktag";
        this.GET_CONTRACT_CHECKED.data.map((item) => {
          array.push(parseInt(item.document_number));
        });
        this.$store
            .dispatch("clients/assignBulkTag", {
              selected: array,
              tags: this.tagSelection,
              URL: this.$services.endpoints.CONTRACTS_ENDPOINT + "/bulktag",
            })
            .then((res) => {
              this.assigning = false;
              this.tagSelection = [];
              this.selectedData = {};
              this.openTagAddition = false;
              this.$store.commit("clients/TOGGLE_ALL_CONTRACT_CHECKBOX", false);
              // this.$services.helpers.notification('Tag(s) assigned to contract(s)', 'success', this)
              this.$toast.success(this.$t("tags_assigned"));
              this.getContracts();
            })
            .catch((err) => {
              this.assigning = false;
              this.$services.helpers.notification(
                  err.response.data[this.locale_message],
                  "error",
                  this
              );
            });
      } else {
        this.$toast.warning(this.$t("choose_contract"));
      }
    },
    openTagBottom() {
      this.openTagAddition = true;
      this.selectedData = {};
    },
    openTag(data) {
      this.selectedData = data;
      this.openTagAddition = true;
    },
    removeTag(data) {
      this.$store
          .dispatch("clients/removeTags", data)
          .then((_) => {
            this.getContractTags();
          })
          .catch((err) => {
            this.$services.helpers.notification(
                err.response.data[this.locale_message],
                "error",
                this
            );
          });
    },
    toggleScheduleContractCancelationModal() {
      // this function is called by bulkAction button and when the schedule icon in a Action column is clicked
      // this function opens schedule cacnellation modal and closes other modals like the warning modal for already scheduled rows
      this.openAlreadyScheduledModal = false;
      this.openScheduleContractCancelationModal = true;
    },
    singleRowSchedule(data) {
      // populate targetRow variable and unset all other variables which represent bulk action
      this.isBulk = false;
      this.targetRow = {...data};
      this.alreadyScheduled = [];
      this.bulkScheduled = [];
      this.excludeRow = []
      this.contractRowList = []
      this.invoiceTextAfterPriceChange = ''

      // check if this row already has scheduled cancelation
      if (this.targetRow.scheduled_termination.length) {
        this.date_to_cancel =
            this.targetRow.scheduled_termination[0].date_to_cancel;
        this.type_of_cancellation =
            this.targetRow.scheduled_termination[0].action;

      } else {
        this.date_to_cancel = TODAY;
        this.type_of_cancellation = "";
      }

      this.toggleScheduleContractCancelationModal(); //display the schedule cancellation modal
    },
    addScheduleContractCancelation() {
      // this function hits the POST route for scheduling contract cancellation
      this.scheduling = true;
      let contracts = [];
      // check if it is bulk or if it is coming from single row
      if (this.isBulk) {
        contracts = this.bulkScheduled;
      } else {
        contracts = [this.targetRow.document_number];
      }
      this.$store
          .dispatch("clients/addScheduleContractCancelation", {
            contracts: contracts,
            type_of_cancellation: this.type_of_cancellation,
            date_to_cancel: moment(this.date_to_cancel).format("YYYY-MM-DD"),
          })
          .then((res) => {
            this.clearContractCancellationInputs();
            this.getContracts();
            this.getContractCustomizeHeader();
            this.$services.helpers.notification(
                res.data[this.locale_message],
                "success",
                this
            );
            this.type_of_cancellation = "";
            this.date_to_cancel = TODAY;
          })
          .catch((err) => {
            this.scheduling = false;
            this.$services.helpers.notification(
                err.response.data[this.locale_message],
                "error",
                this
            );
          });
    },
    deleteScheduleContractCancelation() {
      // this function hits the DELETE route for scheduling contract cancellation
      this.scheduling = true;
      this.$store
          .dispatch(
              "clients/deleteScheduleContractCancelation",
              this.targetRow.scheduled_termination[0].id
          )
          .then((res) => {
            this.clearContractCancellationInputs();
            this.getContracts();
            this.getContractCustomizeHeader();
            this.$services.helpers.notification(
                res.data[this.locale_message],
                "success",
                this
            );
          })
          .catch((err) => {
            this.scheduling = false;
            this.$services.helpers.notification(
                err.response.data[this.locale_message],
                "error",
                this
            );
          });
    },
    updateScheduleContractCancelation() {
      // this function hits the PUT route for scheduling contract cancellation
      this.scheduling = true;
      this.$store
          .dispatch("clients/updateScheduleContractCancelation", {
            id: this.targetRow.scheduled_termination[0].id,
            type_of_cancellation: this.type_of_cancellation,
            date_to_cancel: moment(this.date_to_cancel).format("YYYY-MM-DD"),
          })
          .then((res) => {
            this.clearContractCancellationInputs();
            this.getContracts();
            this.getContractCustomizeHeader();
            this.$services.helpers.notification(
                res.data[this.locale_message],
                "success",
                this
            );
          })
          .catch((err) => {
            this.scheduling = false;
            this.$services.helpers.notification(
                err.response.data[this.locale_message],
                "error",
                this
            );
          });
    },
    toggleContractPricesModal() {
      this.openAlreadyPriceChangeModal = false;
      this.openPriceChangeModal = true;
    },
    singleRowPrice(data) {
      // populate targetRow variable and unset all other variables which represent bulk action
      this.isBulk = false;
      this.targetRow = {...data};
      this.alreadyScheduled = [];
      this.bulkScheduled = [];
      this.excludeRow = []

      // check if this row already has scheduled cancellation
      if (this.targetRow.scheduled_price_change.length) {
        this.contractPriceChangeType = this.targetRow.scheduled_price_change[0].change_type;
        this.contractPriceUpdateDate = this.targetRow.scheduled_price_change[0].date_to_update;
        this.contractPriceChangePercentage = this.targetRow.scheduled_price_change[0].percentage_or_amount;
        this.excludeRow = this.targetRow.scheduled_price_change[0].rows_to_exclude
      } else {
        this.contractPriceChangeType = "";
        this.contractPriceUpdateDate = TODAY;
        this.contractPriceChangePercentage = 0.0;
        this.excludeRow = []
      }
      this.contractRowList = this.targetRow['invoice_rows']

      this.toggleContractPricesModal(); //display the schedule cancellation modal
    },
    addContractPriceUpdate() {
      this.contractPriceUpdateDate = moment(
          this.contractPriceUpdateDate
      ).format("YYYY-MM-DD");

      // check the update date and then call respective function
      if (this.contractPriceUpdateDate === TODAY) {
        // update immediately
        this.updateToday();
      } else {
        // schedule for later
        this.updateLater();
      }

      this.openPriceChangeModal = false;
    },
    updateToday() {
      let payload = {};

      // check if current operation is a bulk action, and prepare the payload accordingly
      if (!this.isBulk) {
        payload = {
          selected: [this.targetRow.document_number],
          change_type: this.contractPriceChangeType,
          percentage_or_amount: this.contractPriceChangePercentage,
          invoice_text: this.invoiceTextAfterPriceChange,
        };
      } else {
        payload = {
          selected: this.bulkScheduled,
          change_type: this.contractPriceChangeType,
          percentage_or_amount: this.contractPriceChangePercentage,
          invoice_text: this.invoiceTextAfterPriceChange,
        };
      }
      if (this.hasManyContract === false) {
        payload['rows_to_exclude'] = []
        if (this.excludeRow.length > 0) {
          payload['rows_to_exclude'] = this.excludeRow
        }

      }


      this.$store
          .dispatch("clients/onAddcontractPriceUpdateToday", {
            ...payload,
          })
          .then((res) => {
            // this.openPriceChangeModal = false     //hide the cancellation modal
            this.clearContractPriceUpdateInputs();
            this.getContracts();
            this.getContractCustomizeHeader();
            this.openPriceChangeModal = false
            this.$services.helpers.notification(
                res.data[this.locale_message],
                "success",
                this
            );
          })
          .catch((err) => {
            this.scheduling = false;
            this.$services.helpers.notification(
                err.response.data[this.locale_message],
                "error",
                this
            );
          });
    },
    updateLater() {
      let payload = {};

      // check if current operation is a bulk action, and prepare the payload accordingly
      if (!this.isBulk) {
        payload = {
          contracts: [this.targetRow.document_number],
          date_to_update: this.contractPriceUpdateDate,
          change_type: this.contractPriceChangeType,
          percentage_or_amount: this.contractPriceChangePercentage,
          invoice_text: this.invoiceTextAfterPriceChange,
        };
      } else {
        payload = {
          contracts: this.bulkScheduled,
          date_to_update: this.contractPriceUpdateDate,
          change_type: this.contractPriceChangeType,
          invoice_text: this.invoiceTextAfterPriceChange,
          percentage_or_amount: this.contractPriceChangePercentage,
        };
      }
      if (this.hasManyContract === false) {
        if (this.hasManyContract === false) {
          payload['rows_to_exclude'] = []
          if (this.excludeRow.length > 0) {
            payload['rows_to_exclude'] = this.excludeRow
          }
        }
      }

      this.$store
          .dispatch("clients/onAddContractPriceUpdate", {
            ...payload,
          })
          .then((res) => {
            // this.openPriceChangeModal = false     //hide the cancellation modal
            this.clearContractPriceUpdateInputs();
            this.getContracts();
            this.getContractCustomizeHeader();
            this.openPriceChangeModal = false
            this.$services.helpers.notification(
                res.data[this.locale_message],
                "success",
                this
            );
          })
          .catch((err) => {
            this.scheduling = false;
            this.$services.helpers.notification(
                err.response.data[this.locale_message],
                "error",
                this
            );
          });
    },
    updateContractPriceUpdate() {
      this.scheduling = true;
      let payload = {
        // id: this.targetRow.scheduled_price_change[0].id,
        date_to_update: moment(this.contractPriceUpdateDate).format(
            "YYYY-MM-DD"
        ),
        change_type: this.contractPriceChangeType,
        percentage_or_amount: this.contractPriceChangePercentage,
        invoice_text: this.invoiceTextAfterPriceChange,
      }
      if (this.hasManyContract === false) {
        if (this.hasManyContract === false) {
          payload['rows_to_exclude'] = []
          if (this.excludeRow.length > 0) {
            payload['rows_to_exclude'] = this.excludeRow
          }

        }
      }
      this.$store
          .dispatch("clients/onUpdateContractPriceUpdate", {
            data: payload,
            id: this.targetRow.scheduled_price_change[0].id,
          })
          .then((res) => {
            this.clearContractPriceUpdateInputs();
            this.getContracts();
            this.getContractCustomizeHeader();
            this.openPriceChangeModal = false
            this.$services.helpers.notification(
                res.data[this.locale_message],
                "success",
                this
            );
          })
          .catch((err) => {
            this.scheduling = false;
            this.$services.helpers.notification(
                err.response.data[this.locale_message],
                "error",
                this
            );
          });
    },
    deleteContractPriceUpdate() {
      this.scheduling = true;
      this.$store
          .dispatch(
              "clients/deleteContractPriceUpdate",
              this.targetRow.scheduled_price_change[0].id
          )
          .then((res) => {
            this.openPriceChangeModal = false
            this.clearContractPriceUpdateInputs();
            this.getContracts();
            this.getContractCustomizeHeader();
            this.$services.helpers.notification(
                res.data[this.locale_message],
                "success",
                this
            );
          })
          .catch((err) => {
            this.scheduling = false;
            this.$services.helpers.notification(
                err.response.data[this.locale_message],
                "error",
                this
            );
          });
    },

    // helper functions to clear the inputs
    clearContractCancellationInputs() {
      this.scheduling = false;
      this.openScheduleContractCancelationModal = false;
      this.action = "";
      this.type_of_cancellation = "";
      this.date_to_cancel = TODAY;
    },
    clearContractPriceUpdateInputs() {
      this.scheduling = false;
      this.targetRow = {};
      this.alreadyScheduled = [];
      this.bulkScheduled = [];
      this.isBulk = false;
      this.contractPriceChangePercentage = 0;
      this.contractPriceChangeType = "";
      this.contractPriceUpdateDate = TODAY;
      this.openPriceChangeModal = false;
      this.openAlreadyPriceChangeModal = false;
    },

    slist(target) {
      // (A) SET CSS + GET ALL LIST ITEMS
      target.classList.add("slist");
      let items = target.getElementsByTagName("li"),
          current = null;

      // (B) MAKE ITEMS DRAGGABLE + SORTABLE
      for (let i of items) {
        // (B1) ATTACH DRAGGABLE
        i.draggable = true;

        // (B2) DRAG START - YELLOW HIGHLIGHT DROPZONES
        i.ondragstart = (ev) => {
          current = i;
          for (let it of items) {
            if (it != current) {
              it.classList.add("hint");
            }
          }
        };

        // (B3) DRAG ENTER - RED HIGHLIGHT DROPZONE
        i.ondragenter = (ev) => {
          if (i != current) {
            i.classList.add("active");
          }
        };

        // (B4) DRAG LEAVE - REMOVE RED HIGHLIGHT
        i.ondragleave = () => {
          i.classList.remove("active");
        };

        // (B5) DRAG END - REMOVE ALL HIGHLIGHTS
        i.ondragend = () => {
          for (let it of items) {
            it.classList.remove("hint");
            it.classList.remove("active");
          }
        };

        // (B6) DRAG OVER - PREVENT THE DEFAULT "DROP", SO WE CAN DO OUR OWN
        i.ondragover = (evt) => {
          evt.preventDefault();
        };

        // (B7) ON DROP - DO SOMETHING
        i.ondrop = (evt) => {
          evt.preventDefault();
          if (i != current) {
            let currentpos = 0,
                droppedpos = 0;
            for (let it = 0; it < items.length; it++) {
              if (current == items[it]) {
                currentpos = it;
              }
              if (i == items[it]) {
                droppedpos = it;
              }
            }

            if (currentpos < droppedpos) {
              i.parentNode.insertBefore(current, i.nextSibling);
            } else {
              i.parentNode.insertBefore(current, i);
            }

            let index = 0;
            const temp = [];
            for (let it of items) {
              let text = it.getElementsByTagName("span")[0].textContent;
              let textKey = this.contractCustomizeItem.find(
                  (item) => this.$t(item) == text
              );
              // let textKeyIndex = this.contractCustomizeItem.indexOf(textKey);
              temp[index] = textKey;
              index++;
            }

            debounce(() => {
              for (let i = 0; i < temp.length; i++) {
                this.contractCustomizeItem[i] = temp[i];
              }
            }, 100)();
          }
        };
      }
    },
  },
};
</script>

<style lang="scss" scoped>
// TODO: change styling for active-filter class
.active-filter {
  box-shadow: 5px 5px 3px #888888 !important;
}


.content {
  padding: 10px 20px;
  padding-top: 90px;
  background-color: #f6f8fc;
}

.content .headers {
  margin: 30px 0 10px;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -moz-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.content .headers h1 {
  font-weight: 500;
  font-size: 24px;
  line-height: 36px;
  color: #333269;
}

.content .headers a svg path {
  -webkit-transition: fill 0.4s ease-out;
  -o-transition: fill 0.4s ease-out;
  transition: fill 0.4s ease-out;
}

.content .headers a:hover svg path {
  fill: #4946ae;
}

.content nav {
  margin: 10px 0 0 5px;
}

@media (max-width: 1094px) {
  .content nav .row {
    display: block;
  }
  .content nav .row > div:last-of-type {
    margin-top: 10px;
  }
  .content nav .row ul {
    -webkit-flex-wrap: wrap;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
  }
  .content nav .row ul li {
    margin-top: 5px;
    margin-bottom: 5px;
  }
}

.content nav ul {
  margin: 0;
  margin-top: 10px;
  text-align: center;
}

.content nav ul li {
  border-radius: 4px;
  -webkit-box-shadow: 0px 3px 5px rgba(9, 30, 66, 0.2),
  0px 0px 1px rgba(9, 30, 66, 0.31);
  box-shadow: 0px 3px 5px rgba(9, 30, 66, 0.2),
  0px 0px 1px rgba(9, 30, 66, 0.31);
  font-size: 14px;
  line-height: 32px;
  color: #ffffff;
  cursor: pointer;
  width: 100px;
  height: 32px;
  -webkit-transition: -webkit-transform 0.35s ease-in-out,
  -webkit-box-shadow 0.3s ease-in-out;
  transition: -webkit-transform 0.35s ease-in-out,
  -webkit-box-shadow 0.3s ease-in-out;
  -o-transition: transform 0.35s ease-in-out, box-shadow 0.3s ease-in-out;
  transition: transform 0.35s ease-in-out, box-shadow 0.3s ease-in-out;
  transition: transform 0.35s ease-in-out, box-shadow 0.3s ease-in-out,
  -webkit-transform 0.35s ease-in-out, -webkit-box-shadow 0.3s ease-in-out;
}

.content nav ul li:hover {
  -webkit-transform: translateY(-0.25em);
  -ms-transform: translateY(-0.25em);
  transform: translateY(-0.25em);
}

.content nav ul li.all {
  background: #c0beff;
}

.content nav ul li.all:hover {
  -webkit-box-shadow: 0 0.5em 0.5em -0.1em #c0beff;
  box-shadow: 0 0.5em 0.5em -0.1em #c0beff;
}

.content nav ul li.inactive {
  background: #efb008;
}

.content nav ul li.inactive:hover {
  -webkit-box-shadow: 0 0.5em 0.5em -0.1em #efb008;
  box-shadow: 0 0.5em 0.5em -0.1em #efb008;
}

.content nav ul li.terminated {
  background: #fb4b4b;
}

.el-clickable {
  cursor: pointer !important;
}

.list-summary {
  font-size: 14px;
  line-height: 22px;
  color: #000000;
  margin-bottom: 0px;
  font-weight: 600;
}

.content nav ul li.terminated:hover {
  -webkit-box-shadow: 0 0.5em 0.5em -0.1em #fb4b4b;
  box-shadow: 0 0.5em 0.5em -0.1em #fb4b4b;
}

.content nav ul li.active {
  background: #419e6a;
}

.content nav ul li.active:hover {
  -webkit-box-shadow: 0 0.5em 0.5em -0.1em #419e6a;
  box-shadow: 0 0.5em 0.5em -0.1em #419e6a;
}

.content nav ul li.upcoming {
  background: #4d82f3;
}

.content nav ul li.upcoming:hover {
  -webkit-box-shadow: 0 0.5em 0.5em -0.1em #4d82f3;
  box-shadow: 0 0.5em 0.5em -0.1em #4d82f3;
}

.content nav ul li:not(:last-of-type) {
  margin-right: 15px;
}

.content nav .right-parent {
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -moz-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}

@media (min-width: 1097px) {
  .content nav .right-parent {
    -webkit-box-pack: end;
    -webkit-justify-content: flex-end;
    -moz-box-pack: end;
    -ms-flex-pack: end;
    justify-content: flex-end;
  }
}

.content nav .right-parent .filter {
  margin-right: 20px;
  margin-top: 10px;
}

.content nav .right-parent .filter label {
  font-size: 14px;
  line-height: 22px;
  color: #000000;
}

.content nav .right-parent .filter select {
  margin: 0 10px 0 10px;
  font-size: 14px;
  line-height: 22px;
  color: #000000;
  border: none;
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.13);
  border-radius: 5px;
  padding-left: 7px;
  padding-right: 10px;
  height: 30px;
}

.content nav .right-parent .filter select:focus {
  outline: none;
}

.content nav .right-parent .filter button {
  background: #5855d6;
  border-radius: 4px;
  padding: 0 16px;
  border: none;
  color: #f6f8fc;
  font-size: 14px;
  line-height: 22px;
  height: 30px;
  -webkit-transition: all 0.4s ease-out;
  -o-transition: all 0.4s ease-out;
  transition: all 0.4s ease-out;
}

.content nav .right-parent .filter button:hover {
  background-color: #4947b0;
  color: #fff;
}

@media (max-width: 767.98px) {
  .content nav .right-parent .filter {
    margin-top: 10px;
  }
}

@media (max-width: 575.98px) {
  .content nav .right-parent .filter {
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-flex-wrap: wrap;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -moz-box-align: center;
    -ms-flex-align: center;
    align-items: center;
  }
  .content nav .right-parent .filter * {
    margin: 5px !important;
  }
}

.content nav .right-parent .search {
  margin-right: 10px;
  margin-top: 10px;
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  height: 30px;
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.13);
  border-radius: 5px;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -moz-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  width: 207.73px;
}

@media (max-width: 767.98px) {
  .content nav .right-parent .search {
    margin-top: 10px;
  }
}

@media (max-width: 296px) {
  .content nav .right-parent .search {
    margin: 10px 0 0;
  }
}

.content nav .right-parent .search label {
  position: absolute;
  left: 0.5rem;
}

.content nav .right-parent .search input {
  border: none;
  width: 77%;
  margin-left: auto;
}

.content nav .right-parent .search input:focus {
  outline: none;
}

.content nav .right-parent .customize {
  margin-top: 10px;
}

@media (max-width: 767.98px) {
  .content nav .right-parent .customize {
    margin-top: 10px;
  }
}

@media (max-width: 296px) {
  .content nav .right-parent .customize {
    -webkit-flex-basis: 100%;
    -ms-flex-preferred-size: 100%;
    flex-basis: 100%;
  }
}

.content nav .right-parent .customize a {
  font-size: 14px;
  line-height: 22px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -moz-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  color: #5855d6;
  text-decoration: none;
  -webkit-transition: color 0.4s ease-out;
  -o-transition: color 0.4s ease-out;
  transition: color 0.4s ease-out;
}

.content nav .right-parent .customize a svg {
  margin-right: 10px;
}

.content nav .right-parent .customize a svg path {
  -webkit-transition: fill 0.4s ease-out;
  -o-transition: fill 0.4s ease-out;
  transition: fill 0.4s ease-out;
}

.content nav .right-parent .customize a:hover {
  color: #4946ae;
}

.content nav .right-parent .customize a:hover svg path {
  fill: #4946ae;
}

.content .box {
  background: #ffffff;
  -webkit-box-shadow: 0px 2.93422px 4.89036px rgba(9, 30, 66, 0.2),
  0px 0px 0.978073px rgba(9, 30, 66, 0.31);
  box-shadow: 0px 2.93422px 4.89036px rgba(9, 30, 66, 0.2),
  0px 0px 0.978073px rgba(9, 30, 66, 0.31);
  border-radius: 3.91229px;
  margin-top: 20px;
}

@media (max-width: 767.98px) {
  .content .box {
    margin-top: 10px;
  }
}

.content .box table {
  width: 100%;
  text-align: center;
  min-width: 1041px;
}

.content .box table .checkbox {
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -moz-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -moz-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  margin-right: 10px;
  margin-left: 5px;
}

.content .box table .checkbox input {
  border: 0.978073px solid #64748b;
  border-radius: 3.91229px;
  height: 15px;
  width: 15px;
  position: relative;
  z-index: 33;
  background: #fffbfb;
  cursor: pointer;
  -webkit-transition: all 0.4s ease-in-out;
  -o-transition: all 0.4s ease-in-out;
  transition: all 0.4s ease-in-out;
}

.content .box table .checkbox input:checked {
  border: none;
  background: transparent;
}

.content .box table .checkbox input,
.content .box table .checkbox input:checked {
  -moz-appearance: none;
  -webkit-appearance: none;
  -o-appearance: none;
}

.content .box table .checkbox input:checked ~ svg {
  display: block;
}

.content .box table .checkbox svg {
  position: absolute;
  height: 17px;
  width: 17px;
  display: none;
  z-index: 1;
  -webkit-transition: all 0.4s ease-in-out;
  -o-transition: all 0.4s ease-in-out;
  transition: all 0.4s ease-in-out;
}

.content .box table thead tr {
  border-bottom: 0.978073px solid #cbd4e1;
}

.content .box table thead th {
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  color: #000000;
  padding-top: 25px;
  padding-bottom: 25px;
}

.content .box table thead th span {
  cursor: pointer;
  display: inline-block;
  margin: 0 5px;
}

.content .box table thead th .checkbox {
  margin: 0 5px;
}

.content .box table thead th:first-of-type {
  padding-left: 10px;
}

.content .box table thead th:last-of-type {
  padding-right: 10px;
}

.content .box table tbody tr {
  -webkit-transition: background 0.2s ease-out;
  -o-transition: background 0.2s ease-out;
  transition: background 0.2s ease-out;
}

.content .box table tbody tr:hover {
  background-color: #f8fbff !important;
}

.content .box table tbody tr.terminated td:last-of-type button:nth-of-type(1),
.content .box table tbody tr.terminated td:last-of-type button:nth-of-type(2) {
  opacity: 0.5;
  pointer-events: none;
}

.content .box table tbody tr.inactive td:last-of-type button:nth-of-type(1) {
  opacity: 0.5;
  pointer-events: none;
}

.content .box table tbody tr:nth-child(odd) {
  background: #f1f4f9;
}

.content .box table tbody td {
  font-size: 14px;
  line-height: 22px;
  color: #000000;
}

.content .box table tbody td:first-of-type {
  padding-left: 10px;
}

.content .box table tbody td:last-of-type {
  padding-right: 10px;
  text-align: right;
}

.content .box table tbody td a {
  text-decoration: none;
  display: block;
  color: #000;
  padding: 10px 5px;
}

.content .box table tbody td span {
  font-size: 13.5286px;
  border-radius: 4px;
  width: 79.24px;
  height: 21.26px;
  line-height: 21.26px;
  display: block;
  text-align: center;
}

.content .box table tbody td span.inactive {
  background: #ffde81;
  color: #976400;
}

.content .box table tbody td span.terminated {
  background: #ffc4c4;
  color: #fb0000;
}

.content .box table tbody td span.active {
  background: #a5e1bf;
  color: #00632b;
}

.content .box table tbody td span.upcoming {
  background: #7ea5f8;
  color: #fbfbfb;
}

.content .box table tbody td button {
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
}

.content .box table tbody td button:not(:last-of-type) {
  margin-right: 10px;
}

.content .box table tbody td button svg path {
  -webkit-transition: fill 0.4s ease-out;
  -o-transition: fill 0.4s ease-out;
  transition: fill 0.4s ease-out;
}

.content .box table tbody td button:hover svg path {
  fill: #4946ae;
}

.content .actions {
  margin-top: 30px;
  margin-bottom: 20px;
}

.content .actions label {
  font-size: 14px;
  line-height: 22px;
  color: #000000;
}

.content .actions select {
  margin: 0 15px 0 10px;
  font-size: 14px;
  line-height: 22px;
  color: #000000;
  border: none;
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.13);
  border-radius: 5px;
  padding-left: 7px;
  padding-right: 10px;
  height: 30px;
}

.content .actions select:focus {
  outline: none;
}

.content .actions button {
  background: #5855d6;
  border-radius: 4px;
  padding: 0 16px;
  border: none;
  color: #f6f8fc;
  font-size: 14px;
  line-height: 22px;
  height: 30px;
  -webkit-transition: all 0.4s ease-out;
  -o-transition: all 0.4s ease-out;
  transition: all 0.4s ease-out;
}

.content .actions button:hover {
  background-color: #4947b0;
  color: #fff;
}

@media (max-width: 575.98px) {
  .content .actions {
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-flex-wrap: wrap;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -moz-box-align: center;
    -ms-flex-align: center;
    align-items: center;
  }
  .content .actions * {
    margin: 5px !important;
  }
}

.sync-btn {
  height: 30px;
  width: 31px;
  position: relative;
  margin-left: 10px;
}

.sync-btn i {
  position: absolute;
  top: 3px;
  left: 4px;
  font-size: 20px !important;
}

.content {
  padding: 90px 30px 10px !important;
}

// TODO: removing default styles of date picker
// .dp__input_icon_pad {
//   box-shadow: none !important;
//   background: transparent !important;
//   width: 100% !important;
// }

.confirmModal {
  text-align: center;

  & .confirmModalButtons {
    display: flex;
    justify-content: space-around;
    margin-top: 12px;

    & .btn-info--confirm {
      color: #fff;
      background-color: #00d4c1;
      border-color: #00d4c1;
    }
  }
}

.form select {
  background: #f0eff5;
  -webkit-box-shadow: 0px 1px 1px rgba(9, 30, 66, 0.25),
  0px 0px 1px rgba(9, 30, 66, 0.31);
  box-shadow: 0px 1px 1px rgba(9, 30, 66, 0.25),
  0px 0px 1px rgba(9, 30, 66, 0.31);
  border-radius: 4px;
  height: 42px;
  width: 150px;
  border: none;
  text-indent: 5px;
}

.form select.big {
  width: 192px;
}

.form .radio {
  display: -webkit-inline-box;
  display: -webkit-inline-flex;
  display: -moz-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  background: #333269;
  border-radius: 4px;
  color: #d2d1d7;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -moz-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 1px;
}

.formc .radio input {
  display: none;
}

.form.radio input:checked + label {
  background: #f6f8fc;
  color: #000000;
}

.form .radio label {
  margin: 0;
  cursor: pointer;
  padding: 1px 11.5px;
  height: 22px;
  line-height: 22px;
  text-align: center;
  -webkit-transition: all 0.3s ease-out;
  -o-transition: all 0.3s ease-out;
  transition: all 0.3s ease-out;
  border-radius: 4px;
}

.form .radio label:first-of-type {
  margin-right: 10px;
}


.form button {
  background: #5855d6;
  width: 126px;
  height: 38px;
  -webkit-box-shadow: 0px 3px 5px rgba(9, 30, 66, 0.2),
  0px 0px 1px rgba(9, 30, 66, 0.31);
  box-shadow: 0px 3px 5px rgba(9, 30, 66, 0.2),
  0px 0px 1px rgba(9, 30, 66, 0.31);
  border-radius: 4px;
  font-size: 14px;
  line-height: 22px;
  color: #ffffff;
  border: none;
  margin-top: 20px;
  margin-bottom: 30px;
  margin-left: 3%;
  -webkit-transition: all 0.4s ease-out;
  -o-transition: all 0.4s ease-out;
  transition: all 0.4s ease-out;
}

.form button:hover {
  background-color: #4947b0;
  color: #fff;
}

.form textarea {
  background: #f0eff5;
  border-radius: 5px;
  height: 78px;
  resize: none;
  width: 100%;
  font-size: 12px;
  line-height: 18px;
  color: #000000;
  border: none;
  padding: 10px;
}

.form textarea:focus {
  border: none;
  outline: none;
}

.form .inputFields {
  background: #f0eff5;
  -webkit-box-shadow: 0px 1px 1px rgba(9, 30, 66, 0.25),
  0px 0px 1px rgba(9, 30, 66, 0.31);
  box-shadow: 0px 1px 1px rgba(9, 30, 66, 0.25),
  0px 0px 1px rgba(9, 30, 66, 0.31);
  border-radius: 4px;
  border: none;
  height: 42px;
  width: 95px;
  text-indent: 10px;
  padding-right: 5px;

}

.form .inputFields.big {
  width: 192px;
}

.form .inputFields:-moz-read-only {
  background: #f0eff5;
}

.form .inputFields:read-only {
  background: #f0eff5;
}

.form .inputFields:focus {
  outline: none;
}

.form .inputFields.input[type="date"] {
  text-indent: 5px;
}

.form .inputFields.input[type="date"]::-webkit-clear-button,
.form .inputFields.input[type="date"]::-webkit-inner-spin-button,
.form .inputFields.input[type="date"]::-webkit-calendar-picker-indicator,
.form .inputFields.input[type="date"]::-webkit-outer-spin-button {
  display: none;
  -webkit-appearance: none;
  appearance: none;
}

.form .inputFields.input[type="number"] {
  width: 55px;
  -webkit-appearance: textfield;
  appearance: textfield;
  -moz-appearance: textfield;
}

.form .inputFields.input[type="number"]::-webkit-outer-spin-button,
.form .inputFields.input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

.text-left {
  text-align: left;
}

.form-control {
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  background-color: #f0eff5;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.outline-purple {
  background: #fff !important;
  color: #5855d6 !important;
  border: 1px solid #5855d6 !important;
}
</style>
